import Repository from "@/apis/Repository.js";

const GET = "";

export default {
  getListings() {
    return Repository.get(transformRoute(GET));
  }
};

const transformRoute = (route = "") => {
  return `/cms/listing/${route}`;
};
